import { PaymentRateChart } from "./PaymentRateChart";

export function ProviderAcceptanceRateChart() {
  return (
    <PaymentRateChart
      title="Acceptance rate"
      description="Share of transactions that succeeded or were declined for insufficient funds. Measures processing health per provider, independent of customer fund issues."
      chartType="PROVIDERS_ACCEPTANCE_RATE"
    />
  );
}

export function ProviderSuccessRateChart() {
  return (
    <PaymentRateChart
      title="Success rate"
      description="Share of transactions that resulted in a successful payment, per provider."
      chartType="PROVIDERS_SUCCESS_RATE"
    />
  );
}

export function ProviderCaptureRateChart() {
  return (
    <PaymentRateChart
      title="Capture rate"
      description="Share of transactions that reached capture, per provider."
      chartType="PROVIDERS_CAPTURE_RATE"
    />
  );
}

export function MethodAcceptanceRateChart() {
  return (
    <PaymentRateChart
      title="Acceptance rate"
      description="Share of transactions that succeeded or were declined for insufficient funds. Measures processing health per payment method, independent of customer fund issues."
      chartType="METHODS_ACCEPTANCE_RATE"
    />
  );
}

export function MethodSuccessRateChart() {
  return (
    <PaymentRateChart
      title="Success rate"
      description="Share of transactions that resulted in a successful payment, per payment method."
      chartType="METHODS_SUCCESS_RATE"
    />
  );
}

export function MethodCaptureRateChart() {
  return (
    <PaymentRateChart
      title="Capture rate"
      description="Share of transactions that reached capture, per payment method."
      chartType="METHODS_CAPTURE_RATE"
    />
  );
}
